import React, { useState } from "react";
import { Card, CardHeader, Collapse, Container, Table } from "reactstrap";
import ReactNumeric from "../../../components/ReactNumeric/ReactNumeric";

export const Beneficios = ({ totales, vam, beneficios }) => {
    const [open, setOpen] = useState(false);

    const openCollapse = () => {
        setOpen(!open);
    };

    return (
        <div aria-multiselectable={true} className="card-collapse">
            <Card className="card-plain my-0">
                <CardHeader role="tab">
                    <div data-toggle="collapse" className="expanded c-pointer" onClick={openCollapse}>
                        {"Coberturas Aplicadas"}&nbsp;&nbsp;
                        <i
                            className={
                                !open ? "now-ui-icons arrows-1_minimal-down" : "now-ui-icons arrows-1_minimal-up"
                            }
                        />
                    </div>
                </CardHeader>
                <Collapse isOpen={open}>
                    <Container className="text-center pl-0">
                        <div className={"table-responsive"}>
                            <Table className="adjusttd text-center">
                                <thead className="text-primary">
                                    <tr>
                                        {vam && (
                                            <>
                                                <th className="text-left">Item</th>
                                                <th className="text-left">Beneficio</th>
                                                <th className="text-left">+Valor Incurrido</th>
                                                <th className="text-left">-Valor Excesos</th>
                                                <th className="text-left">-Val No Elegible</th>
                                                <th
                                                    className="text-left"
                                                    title="Valor a pagar sin descontar deducible ni Coaseguro"
                                                >
                                                    =Valor Cubierto
                                                </th>
                                                <th className="text-left">-Valor Deducible</th>
                                                <th className="text-left" title={"Porcentaje Coaseguro"}>
                                                    % Coa
                                                </th>
                                                <th className="text-left" title={"Valor Coaseguro"}>
                                                    -Valor Coa
                                                </th>
                                                <th className="text-left" title={"Total a pagar sin Coaseguro"}>
                                                    Total a pagar
                                                </th>
                                                <th>Notas</th>
                                            </>
                                        )}

                                        {!vam && (
                                            <>
                                                <th className="text-left">Item</th>
                                                <th className="text-left">Cobertura</th>
                                                <th className="text-right">Valor Límite</th>
                                                <th className="text-right">% Sinies</th>
                                                <th className="text-right">% Aseg</th>
                                                <th className="text-right">Mínimo</th>
                                                <th className="text-right">Val Fijo</th>
                                                <th className="text-left">Observaciones</th>
                                            </>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {beneficios.length === 0 ? (
                                        <React.Fragment>
                                            <tr>
                                                <td colSpan={10}>
                                                    <span>No hay información disponible.</span>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ) : (
                                        <React.Fragment>
                                            {beneficios.map((item, index) => (
                                                <tr key={item.cdCobDedSiniestro}>
                                                    {vam && (
                                                        <>
                                                            <td>
                                                                <span>{index + 1}</span>
                                                            </td>
                                                            <td className="text-left">
                                                                <span>{item.nmCobertura}</span>
                                                            </td>
                                                            <td className="text-right">
                                                                <span>
                                                                    <ReactNumeric
                                                                        valuex={item.valSiniestro}
                                                                        readOnly
                                                                        className="form-control-plaintext text-right"
                                                                    />
                                                                </span>
                                                            </td>
                                                            <td className="text-right">
                                                                <span>
                                                                    <ReactNumeric
                                                                        valuex={item.valExceso}
                                                                        readOnly
                                                                        className="form-control-plaintext text-right"
                                                                    />
                                                                </span>
                                                            </td>
                                                            <td className="text-right">
                                                                <span>
                                                                    <ReactNumeric
                                                                        valuex={item.valNoelegible}
                                                                        readOnly
                                                                        className="form-control-plaintext text-right"
                                                                    />
                                                                </span>
                                                            </td>
                                                            {/*<td className="text-left">*/}
                                                            {/*    <span>*/}
                                                            {/*        <ReactNumeric valuex={item.valMinimo} readOnly*/}
                                                            {/*                      className="form-control-plaintext text-right"/>*/}
                                                            {/*    </span>*/}
                                                            {/*</td>*/}
                                                            <td className="text-right">
                                                                <span>
                                                                    <ReactNumeric
                                                                        valuex={item.valCubierto}
                                                                        readOnly
                                                                        className="form-control-plaintext text-right"
                                                                    />
                                                                </span>
                                                            </td>

                                                            <td className="text-left">
                                                                <span>
                                                                    <ReactNumeric
                                                                        valuex={
                                                                            item.valDeducible ? item.valDeducible : 0
                                                                        }
                                                                        readOnly
                                                                        className="form-control-plaintext text-right"
                                                                    />
                                                                </span>
                                                            </td>
                                                            <td className="text-left">
                                                                <span>
                                                                    <ReactNumeric
                                                                        valuex={item.pctVAseg ? item.pctVAseg : 0}
                                                                        readOnly
                                                                        currencySymbol="%"
                                                                        currencySymbolPlacement={"s"}
                                                                        className="form-control-plaintext text-right"
                                                                    />
                                                                </span>
                                                            </td>
                                                            <td className="text-left">
                                                                <span>
                                                                    <ReactNumeric
                                                                        valuex={item.valMontoCoa ? item.valMontoCoa : 0}
                                                                        readOnly
                                                                        className="form-control-plaintext text-right"
                                                                    />
                                                                </span>
                                                            </td>
                                                            <td className="text-left">
                                                                <span>
                                                                    <ReactNumeric
                                                                        valuex={item.valFijo ? item.valFijo : 0}
                                                                        readOnly
                                                                        className="form-control-plaintext text-right"
                                                                    />
                                                                </span>
                                                            </td>

                                                            <td className="text-left">
                                                                <span>{item.observaciones}</span>
                                                            </td>
                                                        </>
                                                    )}
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                    )}
                                    <React.Fragment>
                                        {beneficios.map((item, index) => (
                                            <tr key={item.cdCobertura}>
                                                {!vam && (
                                                    <>
                                                        <td>
                                                            <span>{index + 1}</span>
                                                        </td>
                                                        <td className="text-left">
                                                            <span>{item.nmCobertura}</span>
                                                        </td>
                                                        <td className="text-right">
                                                            <ReactNumeric
                                                                valuex={item.valLimite ? item.valLimite : 0}
                                                                readOnly
                                                                className="form-control-plaintext text-right"
                                                            />
                                                        </td>
                                                        <td className="text-right">
                                                            <ReactNumeric
                                                                valuex={item.pctReclamo ? item.pctReclamo : 0}
                                                                readOnly
                                                                className="form-control-plaintext text-right"
                                                            />
                                                        </td>
                                                        <td className="text-right">
                                                            <ReactNumeric
                                                                valuex={item.pctVAseg ? item.pctVAseg : 0}
                                                                readOnly
                                                                className="form-control-plaintext text-right"
                                                            />
                                                        </td>
                                                        <td className="text-right">
                                                            <ReactNumeric
                                                                valuex={item.valMinimo ? item.valMinimo : 0}
                                                                readOnly
                                                                className="form-control-plaintext text-right"
                                                            />
                                                        </td>
                                                        <td className="text-right">
                                                            <ReactNumeric
                                                                valuex={item.valFijo ? item.valFijo : 0}
                                                                readOnly
                                                                className="form-control-plaintext text-right"
                                                            />
                                                        </td>
                                                        <td className="text-right">
                                                            <span>{item.observaciones}</span>
                                                        </td>
                                                    </>
                                                )}
                                            </tr>
                                        ))}
                                    </React.Fragment>
                                </tbody>
                            </Table>
                        </div>
                    </Container>
                </Collapse>
            </Card>
        </div>
    );
};
